import {z} from 'zod';

export const OAuthCallbackErrorSchema = z.object({
  name: z.string(), message: z.string(), stack: z.string().optional(), cause: z.unknown().optional(),
  errors: z.array(z.unknown()).optional(), status: z.number().int().min(400).max(599)
}).strict();
